import L from 'leaflet'
import {
  TrackPlayBackControl,
  trackplaybackcontrol
} from './control.playback'

L.TrackPlayBackControl = TrackPlayBackControl
L.trackplaybackcontrol = trackplaybackcontrol
